<template lang="pug">
  .make-an-entry-heart
    .make-an-entry-content
      MakeAnEntryVisibility(text="Always Private")
      section.section.pb-1.pt-2.mt-2
        WtTitle(h4 bold style="margin-bottom:5px") Heart Rate
        .description
          |Measure your heart rate in beats per minute right when you wake up or after you've been resting.!{' '}
          a.link(
            href="https://support-walkertracker-new.helpscoutdocs.com/article/626-how-we-measure-heart-rate"
            target="_blank"
            rel="noopener noreferrer"
          ) Learn more
          | !{' '}about how we measure heart rate.
        BField(
          label="Resting heart rate"
        )
          .is-flex.heart-rate-container
            WtSvgIcon.m-1(icon="icon_heart_rate" width="32px" height="32px")
            BField.heart-rate-field
              BInput.enter-weight-input(
                type="number"
                name="heart"
                :min="45"
                :max="130"
                v-model="heart"
              )
            span.m-1 bpm
        .heart-description Measure your heart rate right when you wake up or after you’ve been resting.
      MakeAnEntryTip.ml-5(:tip-category="'heart'")
      .level.is-mobile.program-settings-form-controls
      .level-left
      .level-right
        .level-item
          WtButton(
            is-text
            color="white"
            style="text-decoration:none"
            size="medium"
            @click.native="reset"
            :disabled="disableReset"
          ) Reset
        .level-item
          WtButton(@click.native="saveEntry" :loading="savingHeart" :disabled="disableSave") SAVE
</template>

<script>
import { mapActions } from "vuex";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";
import MakeAnEntryFooter from "@@/Members/MakeAnEntry/MakeAnEntryFooter";
import MakeAnEntryVisibility from "@@/Members/MakeAnEntry/MakeAnEntryVisibility";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";
import MakeAnEntryTip from "@@/Members/MakeAnEntry/MakeAnEntryTip";

export default {
  name: "MakeAnEntryHeart",

  components: {
    WtTitle,
    WtButton,
    MakeAnEntryFooter,
    WtSvgIcon,
    WtRouterLink,
    MakeAnEntryTip,
    MakeAnEntryVisibility
  },

  mixins: [dateUtilityMixin],

  props: {
    uniqueKey: {
      type: String,
      default: null
    },

    fetchAction: {
      type: Function,
      default: () => {},
      required: true
    },

    entryItem: {
      type: Object,
      default: () => {},
      required: true
    },

    entryDate: {
      type: String,
      default: ""
    },

    formData: {
      type: FormData,
      required: true,
      validator: value => {
        return value instanceof FormData;
      }
    },

    saveEntryWrapper: {
      type: Function,
      required: true
    },

    disableSave: {
      type: Boolean,
      default: true
    },

    disableReset: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      heart: "",
      savingHeart: false
    };
  },

  computed: {
    setFormData() {
      if (!this._.isEmpty(this.entryItem)) {
        // either it's changed or it might have been changed and changed back to what it was
        return (
          this.heart !== this.currentMetricValue || this.formData.has("heart")
        );
      }
      return true;
    },

    currentMetricValue() {
      let metric = this._.find(this.entryItem.wellnessMetrics, {
        type: "heart"
      });
      return this._.get(metric, "value", "");
    }
  },

  watch: {
    heart() {
      if (this.setFormData) {
        this.formData.set("heart", this.heart);
        this.$emit("formDataUpdated", true);
      }
    }
  },

  mounted() {
    this.heart = this.currentMetricValue;
  },

  methods: {
    ...mapActions("members", ["storeJournal", "updateJournal"]),

    saveEntry() {
      this.savingHeart = true;
      this.saveEntryWrapper(this.storeJournal, this.updateJournal);
    },

    reset() {
      const item = "heart";
      if (this.formData.has(item)) {
        this.formData.delete(item);
      }
      let metric = this._.find(this.entryItem.wellnessMetrics, {
        type: item
      });
      this.heart = this._.get(metric, "value", "");
      this.$nextTick(() => {
        this.$emit("formReset", true);
      });
    }
  }
};
</script>

<style lang="sass">
.make-an-entry-heart
  .enter-weight-input
    width: 6rem
  p.help.is-danger
    width: 6rem
  .heart-rate-container
    align-items: center
    .heart-rate-field
      margin-bottom: 0
  .description
    max-width: 600px
    padding-bottom: 40px
    .link
      color: $teal
      text-decoration-color: $teal
      text-decoration: underline
  .heart-description
    font-weight: 100
    font-size: 12px
    padding-top: 5px
    max-width: 240px
  .wellness-visibility
    position: absolute
    right: 1rem
    top: .5rem
.program-settings-form-controls
  margin-top: 20px
</style>
